Vue.component("heista-modal-login", () => import("./components/HeistaModalLogin.vue"));
Vue.component("heista-checkout-info", () => import("./components/HeistaCheckoutInfo.vue"));
Vue.component("heista-opener", () => import("./components/HeistaOpener.vue"));
Vue.component("heista-stepper", () => import("./components/HeistaStepper.vue"));
